<template>
  <div class="wrapper" id="default-wrapper" style="object-fit: cover">
    <template v-if="isVideoDefault">
      <div ref="videoContainer" style="width:100%;height: 100vh">
        <video ref="videoPlayer" :poster="posterURL"
               style="width:100%;height:100%;object-fit:cover;" loop></video>
      </div>
    </template>
    <template v-else>
      <img style="width: 100%; height: auto;" src="static/img/intro.png"/>
      <BaseFormLoading :loading="loading"></BaseFormLoading>
    </template>
  </div>
</template>
<script>

import BaseFormLoading from './base/BaseFormLoading'
import {USER_NAME} from '../constant'
import shaka from 'shaka-player/dist/shaka-player.ui'

export default {
  name: 'Default',
  components: {BaseFormLoading},
  data: function () {
    return {
      loading: false,
      isVideoDefault: false,
      videoURL: null,
      posterURL : null
    }
  },
  computed: {},
  created () {
  },
  mounted () {
    this.$store.commit('clearVideoDefault')
    this.$sendMessageSocket('/app/devices/getDefault', localStorage.getItem(USER_NAME), {})
  },
  methods: {
    generatePlayer (url) {
      if (shaka.Player.isBrowserSupported()) {
        const player = new shaka.Player(this.$refs.videoPlayer)
        const ui = new shaka.ui.Overlay(
          player,
          this.$refs.videoContainer,
          this.$refs.videoPlayer
        )
        ui.getControls().setEnabledNativeControls(false)
        const config = {
          addSeekBar: false,
          controlPanelElements: ['overflow_menu'],
          // overflowMenuButtons: ['cast'],
        }
        ui.configure(config)
        player
          .load(url)
          .then(() => {
            this.$refs.videoPlayer.play()
          }).catch(this.onError)
      }
    }
  },
  watch: {
    '$store.state.videoDefaultUrl': function (value) {
      let that = this
      if (value != null && value) {
        this.isVideoDefault = true
        this.videoURL = value.url;
        this.posterURL = value.image;
        setTimeout(() => {
          that.generatePlayer(value.url)
        }, 100)
      }
    }
  }
}
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
</style>
<style>
#default-wrapper, #default-wrapper iframe {
  width: 100%;
  height: 100vh;
}

#default-wrapper {
  overflow: hidden;
  pointer-events: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Default.vue